import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {tryInitFiveNineProactiveChat, tryInitFiveNineStandardChat} from "./initFiveNine";

export default function FiveNineStarter({config, pageInfo}) {
  useEffect(() => {
    tryInitFiveNineStandardChat({config, pageInfo});

    tryInitFiveNineProactiveChat({config, pageInfo});
  }, []);

  return null;
}
